import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DashboardSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DashboardSVG;
